<template>
  <div id="messages-page">
    <div id="page-header">
      <app-icon
        name="messages"
        size="normal"
        color="#fff" />
      <span id="messages-list-counter">
        {{ contents.oecko.publicMessages.length }}
      </span>
    </div>
    <div id="page">
      <template v-if="contents.oecko.publicMessages.length">
        <div
          v-for="(item, index) in messagesPages[pageOnDisplay]"
          :key="index"
          class="message-item"
          :class="{ left: index % 2 === 0, right: index % 2 !== 0, important: item.important }">
          <span class="subject">{{ item.subject }}</span>
          <span class="info">{{ item | infoFormater }}</span>
          <p>{{ item.content }}</p>
          <span class="counter">{{ (pageOnDisplay * 5) + index + 1 }}/{{ contents.oecko.publicMessages.length }}</span>
        </div>
      </template>
      <template v-else>
        <div id="empty-template">
          Auncun message à afficher
        </div>
      </template>
    </div>

    <div class="dock">
      <div class="dock-banner">
        <div
          class="dock-item"
          @click="changePage('previous')">
          <app-icon
            name="previous"
            size="small"
            :color="messagesPages.length > 1 ? '#fff' : '#1b1b1b'"/>
        </div>
        <div class="dock-item" @click='resetTimer()'>
          <Waiter
            :relativeProgress='timerRelativeProgress'
            icon="replay"
            color="rgba(255,255,255, 1)" />
        </div>
        <div
          class="dock-item"
          @click="changePage('next')">
          <app-icon
            name="next"
            size="small"
            :color="messagesPages.length > 1 ? '#fff' : '#1b1b1b'"/>
        </div>

        <div class="dock-button">
          <app-icon
            @click="stopConsultation()"
            name="dockHomeButton"
            size="inter"
            color="black"/>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
#messages-page
  background: rgba(0,0,0,.65)
  bottom: 0
  display: flex
  flex-direction: column
  left: 0
  padding-bottom: 11rem
  position: absolute
  right: 0
  top: 0
#empty-template
  align-items: center
  color: #fff
  display: flex
  justify-content: center
#page-header
  align-items: center
  display: flex
  height: 12rem
  justify-content: center
  width: 100%
  svg
    fill: #fff
  #messages-list-counter
    align-items: center
    background: #e0e0e0
    border-radius: 50%
    color: $text-color
    display: flex
    font-family: 'RobotoRegular'
    font-size: .9em
    height: 50px
    justify-content: center
    position: absolute
    right: 41%
    top: 2rem
    width: 50px
#page
  align-items: center
  display: flex
  flex-direction: column
  height: 95rem
  justify-content: flex-start
  .message-item
    background: rgba(255,255,255,.95)
    border-radius: 10px
    border-top: 5px solid #00796b
    color: #212121
    // box-shadow: 0 0 4px 1px #00796b
    display: flex
    flex-direction: column
    height: 17rem
    margin-bottom: 2.5rem
    padding: 0 .9rem
    position: relative
    width: 55rem
    &.important
      border-top: 5px solid #c62828
      // box-shadow: 0 0 5px 2px #c62828
      .subject
        color: #c62828
        font-family: 'RobotoBold'
      p
        font-family: 'RobotoRegular'
      .counter
        color: #c62828
    .subject
      color: #00796b
      font-family: 'RobotoMedium'
      font-size: .9em
      line-height: 1em
      margin: .8rem
      margin-top: 1.3rem
    .info
      color: #757575
      font-family: 'RobotoLightItalic'
      font-size: .5em
      margin: .4rem .8rem
    p
      font-family: 'RobotoLight'
      font-size: .7em
      margin: .8rem 0 0 0
      padding-left: 1rem
    .counter
      color: #00796b
      font-family: 'RobotoLightItalic'
      font-size: .5em
      position: absolute
      right: 1.2rem
      top: 1rem
.messages-icon
  margin: 0 1rem
  &.important
    svg
      fill: #373737
    &.active
      svg
        fill: #fff
  &.normal
    svg
      fill: none
      stroke: #373737
      stroke-width: 20px
    &.active
      svg
        stroke: #fff
</style>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';
import Waiter from '@/components/appModules/Waiter.vue';

export default {
  name: 'MessagesPage',

  components: {
    AppIcon,
    Waiter,
  },

  props: {
    contents: Object,
  },

  data() {
    return {
      pageOnDisplay: 0,
      TIMER_DURATION: 35000,
      timerStartTime: null,
      timerRelativeProgress: 0,
      timerAnimation: null,
    };
  },

  computed: {
    messagesPages() {
      this.pageOnDisplay = this.pageOnDisplay || 0;
      let pagesList = [];
      let page = [];

      for (let i = 0; i < this.contents.oecko.publicMessages.length; i += 1) {
        const element = this.contents.oecko.publicMessages[i];
        page.push(element);
        if (page.length === 5 || i === this.contents.oecko.publicMessages.length - 1) {
          pagesList.push(page);
          page = [];
        }
      }

      return pagesList;
    },

    importantClass() {
      return {
        active: this.type !== 'normal',
      };
    },
    normalClass() {
      return {
        active: this.type !== 'important',
      };
    },
  },

  activated() {
    this.timerAnimation = requestAnimationFrame(this.animateTimer);
  },

  deactivated() {
    cancelAnimationFrame(this.timerAnimation);
    this.timerAnimation = null;
    this.timerStartTime = null;
    this.timerRelativeProgress = 0;
    this.pageOnDisplay = null;
  },

  methods: {
    changePage(type) {
      const nextPage = this.pageOnDisplay + 1 >= this.messagesPages.length
        ? 0
        : this.pageOnDisplay + 1;
      const previousPage = this.pageOnDisplay - 1 < 0
        ? this.messagesPages.length - 1
        : this.pageOnDisplay - 1;
      this.pageOnDisplay = type === 'previous' ? previousPage : nextPage;
      this.resetTimer();
    },

    stopConsultation() {
      this.$router.push({ name: 'home' });
    },

    animateTimer(timestamp) {
      if (!this.timerStartTime) this.timerStartTime = timestamp;

      const runTime = timestamp - this.timerStartTime;
      this.timerRelativeProgress = runTime / this.TIMER_DURATION;

      if (runTime < this.TIMER_DURATION) {
        this.timerAnimation = requestAnimationFrame(this.animateTimer);
      } else {
        cancelAnimationFrame(this.timerAnimation);
        this.timerAnimation = null;
        this.timerStartTime = null;
        this.timerRelativeProgress = 0;
        this.stopConsultation();
      }
    },

    resetTimer() {
      cancelAnimationFrame(this.timerAnimation);
      this.timerAnimation = null;
      this.timerStartTime = null;
      this.timerRelativeProgress = 0;
      this.timerAnimation = requestAnimationFrame(this.animateTimer);
    },
  },

  filters: {
    infoFormater(val) {
      const msgDate = new Date(val.formatted_date);
      const optionsD = { weekday: 'long', month: 'long', day: 'numeric' };
      const optionsH = { hour: '2-digit', minute: '2-digit' };
      return `Le ${msgDate.toLocaleDateString('fr-FR', optionsD)} à ${msgDate.toLocaleTimeString('fr-FR', optionsH)} par ${val.sender.used_name}`;
    },
  },
};
</script>
